import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";

const ROUTES = [
  { title: "Joint Development", body: "Develop your land with RK Builders under a structured joint-development arrangement." },
  { title: "Land Sale", body: "Offer your land parcel for outright purchase by the group, subject to verification and documentation." },
  { title: "Project Collaboration", body: "Collaborate on a specific project where your land and our development capability align." },
  { title: "Development Partnership", body: "Long-term development partnerships across our active and upcoming locations." },
];

export default function Landowner() {
  return (
    <div data-testid="landowner-page" className="pt-28 sm:pt-36">
      <SEO title="Landowner Partnerships — RK Builders"
        description="Discuss joint development, land sale, project collaboration, or development partnership with RK Builders." />
      <header className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-14">
        <Eyebrow>For Landowners</Eyebrow>
        <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4 max-w-3xl leading-[1.05]">
          Your Land. <span className="italic text-[#C5A059]">A Measured Partnership.</span>
        </h1>
        <p className="text-base text-[#94A3B8] leading-loose mt-8 max-w-2xl">
          RK Builders works with landowners across our active and upcoming locations. Every discussion begins
          with a direct conversation with the real estate team — not an intermediary.
        </p>
      </header>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
        {ROUTES.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.06} className="bg-[#060A12] p-8">
            <span className="font-serif text-3xl text-[#C5A059]/30">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="font-serif text-xl text-[#FBF9F5] mt-4">{r.title}</h3>
            <p className="text-xs text-[#94A3B8] leading-relaxed mt-3">{r.body}</p>
          </Reveal>
        ))}
      </section>

      <section className="max-w-[900px] mx-auto px-5 sm:px-8 pb-28">
        <Reveal className="border border-white/10 bg-[#0B1320] p-8 sm:p-12">
          <EnquiryForm
            type="landowner"
            title="Start the Conversation"
            intro="Share the essentials. Please do not upload or send property documents through this form — documents are reviewed only in person or through our verified channels."
            fields={[
              { name: "land_location", label: "Land location", required: true, placeholder: "Village / town / area" },
              { name: "total_area", label: "Total area", required: true, placeholder: "e.g. 2 acres" },
              { name: "ownership", label: "Ownership status", type: "select", required: true,
                options: ["Single owner", "Joint / family ownership", "Power of attorney", "Other"] },
              { name: "road_access", label: "Road access", type: "select", options: ["Main road", "Link road", "Internal road", "No direct access"] },
              { name: "maps_link", label: "Google Maps location link", placeholder: "Paste a maps link (optional)" },
              { name: "proposal", label: "Proposal details", type: "textarea", wide: true,
                placeholder: "Joint development, outright sale, collaboration…" },
            ]}
          />
        </Reveal>
      </section>
    </div>
  );
}
